// extracted by mini-css-extract-plugin
export default {"textButton":"TextButton_textButton__LXpf+","buttonTitle":"TextButton_buttonTitle__+QYcj","buttonTitleUnderline":"TextButton_buttonTitleUnderline__B-I+p"};